module.exports = __webpack_public_path__ + "img/21 Kirbisser Darts (2).jpg";